import React from 'react';
import { Form, Radio, Space } from 'antd';
import {FspType,SelfOnboardingConfigDTO} from '@/shared/api/model';
import MobilePaymentHandler from './MobilePaymentHandler';
import BankPaymentHandler from './BankPaymentHandler';
import {FormInstance} from "antd/es/form";

interface PaymentSelectorProps {
    onFspTypeChange: (type: FspType) => void;
    onFspChange: (fsp: string) => void;
    onAmountChange: (amount: string) => void;
    onPhoneNumberChange?: (phone: string) => void;
    config?: SelfOnboardingConfigDTO;
    dark: boolean;
    showOtpInput?: boolean;
    isLinkedNumber?: boolean;
    form: FormInstance<any>;
}

const PaymentSelector: React.FC<PaymentSelectorProps> = ({
                                                             onFspTypeChange,
                                                             onFspChange,
                                                             onAmountChange,
                                                             onPhoneNumberChange,
                                                             config,
                                                             dark,
                                                             showOtpInput,
                                                             isLinkedNumber,
                                                         }) => {
    const [fspType, setFspType] = React.useState<FspType>(FspType.MNO);

    const handlePaymentTypeChange = (e: any) => {
        const type = e.target.value;
        setFspType(type);
        onFspTypeChange(type);
    };

    if(!config) return (<p>Loading ...</p>);

    return (
        <Space direction="vertical" style={{ width: '100%' }}>
            <Form.Item name="fspType" label="Payment Method">
                <Radio.Group onChange={handlePaymentTypeChange} value={fspType}>
                    <Radio value={FspType.MNO}>Mobile Money</Radio>
                    <Radio value={FspType.BANK}>Bank Transfer</Radio>
                </Radio.Group>
            </Form.Item>

            {fspType === FspType.MNO ? (
                <MobilePaymentHandler
                    onFspChange={onFspChange}
                    onAmountChange={onAmountChange}
                    // @ts-ignore
                    onPhoneNumberChange={onPhoneNumberChange}
                    config={config}
                    dark={dark}
                    showOtpInput={showOtpInput}
                    isLinkedNumber={isLinkedNumber}
                />
            ) : (
                <BankPaymentHandler
                    onBankSelect={onFspChange}
                    onAmountChange={onAmountChange}
                    config={config}
                    dark={dark}
                />
            )}
        </Space>
    );
};

export default PaymentSelector;